/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

class IconCalendarToday extends React.Component {
  render() {
    const today = new Date();
    const todayDate = today.getDate();
    const IconToday = require(`./calendarDays/calendar${todayDate}`).default;

    return <IconToday />;
  }
}

IconCalendarToday.defaultProps = {
  className: null
};

IconCalendarToday.propTypes = {
  className: PropTypes.string
};

export default IconCalendarToday;
